module.exports = " <action-list-item contents=\"{\n    iconClass: 'fa-vcard-o',\n    ordinal: $ctrl.contents.ordinal,\n    title: 'How do you intend to use AutomatedAccounting.IO?',\n    description: 'Answers to a few quick questions allows AutomatedAccounting.IO to stay relevant for your needs',\n    state: $state.current.data.baseState + '.preferences',\n    actions: [],\n}\"></action-list-item> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/components/action-list-items/contents/personal-service-usage-intentions-overview.html
// module id = 1744
// module chunks = 86